






























































import TopNav from '@/web/components/navigation/TopNav.vue';
import NavItem from '@/web/components/navigation/NavItem.vue';
import Vue from 'vue';
import { notify } from '@/web/utils/notify';
import { mapGetters } from 'vuex';
import DirtyMixin from '@/web/mixins/DirtyMixin';
import { errorToMessage } from '@/core/utils/errors';

export default Vue.extend({
  name: 'EditPage',
  components: {
    TopNav,
    NavItem,
  },
  mixins: [DirtyMixin],
  data() {
    return {
      inProgress: false,
    };
  },
  computed: {
    ...mapGetters({
      page: 'page/page',
      isPublished: 'page/isPublished',
      formSaveFun: 'globals/formSaveFun',
      teacherStudioUrl: 'user/teacherStudioUrl',
      pagesLocationUrl: 'setting/pagesLocationUrl',
    }),
    selectedTab() {
      return this.$route.name;
    },
    pageUrl() {
      if (!this.page) return;
      return `${this.pagesLocationUrl}/${this.page.slug}`;
    },
  },
  methods: {
    preview() {
      window.open(`${this.pageUrl}`, '_blank');
    },
    copyPageUrl() {
      this.$copyText(this.pageUrl).then(() => {
        notify(this.$t('GENERAL.TOAST.COPIED') as string, this.pageUrl);
      });
    },
    async savePage() {
      if (!this.formSaveFun) return;
      this.inProgress = true;
      try {
        await this.formSaveFun();
        this.$notify({
          group: 'app',
          type: 'success',
          title: this.$t('NOTIFICATIONS.TITLE.SUCCESS') as string,
          text: this.$t('PAGES.NOTIFICATIONS.PAGE_SUCCESSFULLY_UPDATED'),
        });
      } catch (error) {
        this.$notify({
          group: 'app',
          type: 'error',
          title: this.$t('NOTIFICATIONS.TITLE.ERROR') as string,
          text: errorToMessage(
            error.response,
            `${this.$t('PAGES.NOTIFICATIONS.FAILED_TO_CREATE_PAGE')}: ${error}`
          ),
        });
      } finally {
        this.inProgress = false;
      }
    },
  },
  created() {
    const id = this.$route.params.id;
    this.$store.dispatch('page/loadPage', id);
    this.$store.dispatch('setting/getPagesDomain');
  },
});
